import { GameId } from '@bg-shared/enums/GameId';
import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature';
import { ICasinoRecentActionsModel } from '../interfaces';

export const casinoLatestPayinEntity = new StoresEntity(
    class CasinoLatestPayin extends Store<ICasinoRecentActionsModel> {
        constructor(gameId: GameId) {
            super({
                key: `CasinoLatestPayin/${gameId}`,
                default: {
                    recentBets: [],
                    recentWin: null,
                    runId: null,
                    currentBetting: {
                        bets: [],
                        runId: null,
                    },
                },
            });
        }

        public set recentWin(value: string) {
            this.update((draft) => {
                draft.recentWin = value;
            });
        }

        public addBets(runId: number, bets: ICasinoRecentActionsModel['recentBets']): void {
            this.update((draft) => {
                if (draft.runId !== runId) {
                    draft.runId = runId;
                    draft.recentBets = bets;
                } else {
                    draft.recentBets.push(...bets);
                }
            });
        }

        public addCurrentBets(runId: number, bets: ICasinoRecentActionsModel['recentBets']): void {
            this.update((draft) => {
                draft.currentBetting.runId = runId;
                draft.currentBetting.bets = [...draft.currentBetting.bets, ...bets];
            });
        }

        public switchCurrentBetsToRecent(): void {
            this.update((draft) => {
                draft.recentBets = draft.currentBetting.bets;
                draft.runId = draft.currentBetting.runId;
                draft.currentBetting.bets = [];
                draft.currentBetting.runId = null;
            });
        }
    },
);
